import { Shift } from 'modules/shift_management/lib/types'
import type PlannedBreak from 'modules/time_planning/store/internal/models/PlannedBreak'

export type PreviewState = {
  selectedDaysByRow: Record<string, string[]>
  shifts: Shift[]
  plannedBreaks: PlannedBreak[]
  shiftIdsToHide: number[]
}

export type PreviewDispatch = (arg0: PreviewAction) => void

export type PreviewAction =
  | {
      type: 'RESET_DAYS_BY_ROW'
      selectedDaysByRow: Record<string, string[]>
    }
  | {
      type: 'RESET_SHIFTS'
      shifts: Shift[]
    }
  | {
      type: 'RESET_PLANNED_BREAKS'
      plannedBreaks: PlannedBreak[]
    }
  | {
      type: 'HIDE_SHIFTS'
      shiftIdsToHide: number[]
    }
  | {
      type: 'CLEAN_PREVIEW'
    }

export function initialPreviewState(): PreviewState {
  return {
    selectedDaysByRow: {},
    shifts: [],
    plannedBreaks: [],
    shiftIdsToHide: [],
  }
}

export default function reducer(state: PreviewState, action: PreviewAction): PreviewState {
  switch (action.type) {
    case 'RESET_DAYS_BY_ROW': {
      return { ...state, selectedDaysByRow: action.selectedDaysByRow }
    }

    case 'RESET_SHIFTS': {
      return { ...state, shifts: action.shifts }
    }

    case 'RESET_PLANNED_BREAKS': {
      return { ...state, plannedBreaks: action.plannedBreaks }
    }

    case 'HIDE_SHIFTS': {
      return { ...state, shiftIdsToHide: action.shiftIdsToHide }
    }

    case 'CLEAN_PREVIEW': {
      return initialPreviewState()
    }

    default:
      return state
  }
}
